
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { TopicItemProps } from ".";
import { loading, update } from "store/topic";

interface ApiTopicUpdateInputProps extends TopicItemProps {
}

type ApiTopicUpdateOutputProps = OutputBaseProps<{ item: TopicItemProps; }, ApiTopicUpdateInputProps>;

export const apiTopicUpdate = async (data: ApiTopicUpdateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.put<ApiTopicUpdateOutputProps>("/api/topic/update", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(update({ data: res.data.item }));
    }
    return res;
};